import { StorageValue } from './storage-value';

// -----------------------------------------------------------------------------
export class SessionStorage {
  // ---------------------------------------------------------------------------
  public static get keys(): string[] {
    return Object.keys(sessionStorage);
  }

  // ---------------------------------------------------------------------------
  public static get(key: string): StorageValue {
    const val = sessionStorage.getItem(key);
    return new StorageValue(val);
  }

  // ---------------------------------------------------------------------------
  public static getKeysByPrefix(prefix: string): string[] {
    const foundKeys: string[] = [];
    const keys = Object.keys(sessionStorage);

    keys.forEach((key) => {
      if (key.startsWith(prefix)) {
        foundKeys.push(key);
      }
    });

    return foundKeys;
  }

  // ---------------------------------------------------------------------------
  public static set(key: string, val: any): void {
    if (!val) {
      val = '';
    }

    sessionStorage.setItem(key, val);
  }

  // ---------------------------------------------------------------------------
  public static setNumber(key: string, val: number): void {
    sessionStorage.setItem(key, JSON.stringify(val));
  }

  // ---------------------------------------------------------------------------
  public static setBool(key: string, val: boolean): void {
    sessionStorage.setItem(key, JSON.stringify(val));
  }

  // ---------------------------------------------------------------------------
  public static remove(key: string): void {
    sessionStorage.removeItem(key);
  }

  // ---------------------------------------------------------------------------
  public static setObject(key: string, val: object): boolean {
    try {
      sessionStorage.setItem(key, JSON.stringify(val));
      return true;
    } catch (e) {
      return false;
    }
  }
}
